export default __webpack_public_path__ + "static/media/a1.bbca8bbf.png";